import * as React from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Typography } from '@one-thd/sui-atomic-components';
import { shape, bool } from 'prop-types';
import '../styles/app.scss';

export const Error = ({ error, debug }) => {
  const { channel } = React.useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const imageHeight = isMobile ? '60px' : '150px';
  const imageWidth = isMobile ? '200px' : '500px';

  return (
    <div
      id="root__error"
      className="sui-text-center sui-my-12 sui-mx-auto sui-flex sui-justify-center"
    >
      <div className="sui-grid">
        <div className="sui-col-span-6">
          <div data-testid="errorContent">
            <div className="sui-w-full sui-px-12 sui-pt-56 md:sui-px-0">
              <img
                className="sui-mb-10"
                alt=""
                height={imageHeight}
                src="https://assets.thdstatic.com/images/v1/oops.svg"
                width={imageWidth}
              />{' '}
              <Typography variant="h1">
                WE&apos;RE FIXING IT.
              </Typography>
              <div>
                <p>We&apos;ll have this patched up as soon as possible.</p>
              </div>
              {error && debug && (
                <pre>
                  <code>{error.stack}</code>
                </pre>
              )}
              <div>
                <a className="sui-text-primary" href="/">
                  <span>Back to homepage</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Error.propTypes = {
  error: shape({}),
  debug: bool,
};

Error.defaultProps = {
  error: null,
  debug: false,
};
